import { render, staticRenderFns } from "./EventInfo.vue?vue&type=template&id=74afe6de&scoped=true"
import script from "./EventInfo.vue?vue&type=script&lang=js"
export * from "./EventInfo.vue?vue&type=script&lang=js"
import style0 from "./EventInfo.vue?vue&type=style&index=0&id=74afe6de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74afe6de",
  null
  
)

export default component.exports